angular.module('app.filters').filter('usageType', ($filter) => {
  'ngInject';
  return (input) => {
    switch (input) {
      case 'broadcast_duration':
        return 'broadcast';
      case 'viewership':
        return 'viewership';
      case 'captioning':
        return 'caption';
    }
    return '';
  };
});



// WEBPACK FOOTER //
// ./app/filters/usage-type.js